import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CardComponent } from './card.component';
import { ReportingGuard } from 'src/app/guards/reporting.guard';
import { CardHistoryComponent } from './card-history/card-history.component';
import { EditCardComponent } from './edit-card/edit-card.component';
import { CardFilesComponent } from './card-files/card-files.component';
import { AppMaterialModule } from 'src/app/helpers/app-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedPipesModule } from 'src/app/pipes/shared-pipes.module';
import { TranslateStateModule } from 'src/app/pipes/translate-state.module';
import { SharedComponentsModule } from 'src/app/components/shared-components.module';
import { TruncateModule } from 'src/app/pipes/truncate.module';


const routes: Routes = [
  {
    path: '',
    component: CardComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'edit/:id',
    component: EditCardComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'history/:id',
    component: CardHistoryComponent,
    canActivate: [ReportingGuard]
  },
  {
    path: 'files/:id',
    component: CardFilesComponent,
    canActivate: [ReportingGuard]
  },
]

@NgModule({
  declarations: [
    CardComponent,
    EditCardComponent,
    CardFilesComponent,
    CardHistoryComponent,
 
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    AppMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPipesModule,
    SharedComponentsModule,
    TranslateStateModule,
    TruncateModule
  ],
  exports: [RouterModule],
})
export class CardModule { }
